import React from 'react'

import { Building } from 'src/shared/components/icons/building'
import { Separator } from 'src/shared/components/ui/miscellaneous/separator'
import BiographySection from 'src/shared/features/users/components/view-profile/biography-section'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'

import { BadgesSection } from './badges-section'
import { MyLicensesSection } from './my-licenses-section'
import { PublicLicensesSection } from './public-licenses-section'
interface AboutSectionProps {
  user: PublicUserData
  size?: 'default' | 'small'
  isCurrentUser?: boolean
}

export const AboutSection: React.FC<AboutSectionProps> = ({ user, size = 'default', isCurrentUser = false }) => {
  return (
    <div className="flex flex-col gap-6">
      <BiographySection username={user.username} />

      {user.companyName && (
        <>
          <Separator />
          <div className="flex flex-row flex-wrap items-start gap-4 gap-y-0">
            <Building className="size-8" />
            <div className="flex flex-col items-start">
              <h3 className="text-lg font-bold">Works at</h3>
              <p className="text-muted">{user.companyName}</p>
            </div>
          </div>
        </>
      )}
      {!isCurrentUser && (
        <>
          <PublicLicensesSection userId={user.id} />
          <Separator />
        </>
      )}
      <BadgesSection user={user} size={size} />
      {isCurrentUser && <MyLicensesSection />}
    </div>
  )
}

export default AboutSection
